module.exports = __webpack_public_path__ + "img/NANO_COVER.8a83cf26.jpg";